import React from 'react'
import { Detail } from '../../component/detail/Detail'

export default function DetailPage() {
  return (
    <>
      <Detail />
    </>
  )
}
